import {
  Routes,
  Route,
  Navigate,
  Outlet,
  useNavigate,
  useLocation,
} from "react-router-dom";

import { useStore } from "store";

import { Result, Button } from "antd";

import BasePage from "components/Layout/BasePage";
import Base from "components/Layout/Base";

import AdminRFCs from "routes/AdminRFCs";
import Login from "routes/Login";
import Cuenta from "routes/Cuenta";
import CFDI from "routes/CFDI";
import EFOS from "routes/EFOS";
import Certificates from "routes/Certificates";
import Profile from "routes/Profile";
import Alerts from "routes/Alerts";
import Plan from "routes/Plan";
import Reports from "routes/Reports";
import CFDIFileLanding from "routes/CFDIFileLanding";
import EmailTokenLanding from "components/Shared/EmailTokenLanding";
import Register from "routes/Register/components";
import PasswordReset from "./routes/PasswordReset/components";

const AuthLayout = ({ isUserLoggedIn, isOnboarding, routePath }) => {
  if (!!!isUserLoggedIn) {
    return <Navigate to="/login" replace />;
  }

  if (!!isOnboarding) {
    return <Navigate to="/certificados" replace />;
  }

  return <Outlet />;
};

const AdminAuthLayout = ({ isAdmin }) => {
  if (!!!isAdmin) {
    return <NotFound />;
  }

  return <Outlet />;
};

const NotFound = () => {
  const navigate = useNavigate();
  return (
    <Result
      status={404}
      title="404"
      subTitle="¡Ups! La página que buscas no existe."
      extra={
        <Button type="primary" onClick={() => navigate("/")}>
          Regresar
        </Button>
      }
    />
  );
};

export default function RoutesComponent(propcs) {
  // const token = useStore((state) => state.token);
  const user = useStore((state) => state.user);
  const activeRfc = useStore((state) => state.activeRfc);
  const setActiveRfc = useStore((state) => state.setActiveRfc);

  const location = useLocation();

  // const isUserLoggedIn = token && user && user.id_user;
  const isUserLoggedIn = user && user.id_user;

  const routePath = location.pathname;

  let isOnboarding = false;

  if (isUserLoggedIn) {
    if (
      Object.keys(user.rfcs || {}).length <= 0 &&
      activeRfc !== "onboarding"
    ) {
      setActiveRfc("onboarding");
      isOnboarding = true;
    } else if (
      activeRfc === "onboarding" &&
      !["/certificados", "/cuenta"].includes(routePath)
    ) {
      isOnboarding = true;
    }
  }

  return (
    <Routes>
      <Route
        element={
          <AuthLayout
            isUserLoggedIn={!!isUserLoggedIn}
            isOnboarding={!!isOnboarding}
            routePath={routePath}
          />
        }
      >
        <Route
          element={<AdminAuthLayout isAdmin={user.user_level === "admin"} />}
        >
          <Route
            path="/admin/rfcs"
            element={
              <Base>
                <AdminRFCs />
              </Base>
            }
          />
        </Route>
        <Route
          path="/cuenta"
          element={
            <Base>
              <Cuenta />
            </Base>
          }
        />
        <Route
          path="/perfil"
          element={
            <Base>
              <Profile />
            </Base>
          }
        />
        <Route
          path="/reportes"
          element={
            <Base>
              <Reports />
            </Base>
          }
        />
        <Route
          path="/cfdis/:id_cfdi?"
          element={
            <Base>
              <CFDI />
            </Base>
          }
        />
        <Route
          path="/efos"
          element={
            <Base>
              <EFOS />
            </Base>
          }
        />
        <Route
          path="/certificados"
          element={
            <Base>
              <Certificates />
            </Base>
          }
        />
        <Route
          path="/alertas"
          element={
            <Base>
              <Alerts />
            </Base>
          }
        />
        <Route
          path="/plan"
          element={
            <Base>
              <Plan />
            </Base>
          }
        />
      </Route>
      <Route path="/" element={<Navigate replace to="/cfdis" />} />
      <Route
        path="/login"
        element={
          !isUserLoggedIn ? (
            <BasePage>
              <Login />
            </BasePage>
          ) : (
            <Navigate replace to="/cfdis" />
          )
        }
      />
      <Route
        path="/registro"
        element={
          !isUserLoggedIn ? (
            <BasePage>
              <Register />
            </BasePage>
          ) : (
            <Navigate replace to="/cfdis" />
          )
        }
      />
      <Route
        path="/reset"
        element={
          !isUserLoggedIn ? (
            <BasePage>
              <PasswordReset />
            </BasePage>
          ) : (
            <Navigate replace to="/cfdis" />
          )
        }
      />
      <Route
        path="/token-verify"
        element={
          !isUserLoggedIn ? (
            <BasePage>
              <EmailTokenLanding />
            </BasePage>
          ) : (
            <Navigate replace to="/cfdis" />
          )
        }
      />
      <Route
        path="/file"
        element={
          <BasePage>
            <CFDIFileLanding />
          </BasePage>
        }
      />
      <Route
        path="*"
        element={
          !isUserLoggedIn ? <Navigate to="/login" replace /> : <NotFound />
        }
      ></Route>
    </Routes>
  );
}
